import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { t } from '../../../../modules/infra/i18n';

import { setServiceSearch } from '../actions';
import SearchInput from '../../../common/SearchInput';

const ServiceSearchInput = compose(
  connect(
    null,
    { setSearchTerm: setServiceSearch }
  ),
  withProps(() => ({
    placeholder: t('register:sale.service_search.placeholder'),
  })),
)(SearchInput);

export default ServiceSearchInput;
